import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImageFilters, IImageFiltersData } from '../../../imageFilters.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface IAnnotatedByFilterInfoProps {
  availableFilters: IImageFiltersData;
  imageFilters: IImageFilters;
}

export const AnnotatedByFilterInfo = observer((props: IAnnotatedByFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const selectedOptions = props.availableFilters.annotatedBy
    .slice()
    .sort((a, b) => (a.email > b.email ? 1 : -1))
    .filter((d) => props.imageFilters.annotatedBy.includes(d.id));

  return (
    <FiltersDropdownRow
      label={t('image_filters.annotatedBy')}
      count={selectedOptions.length}
    >
      <>
        {selectedOptions.map((d) => (
          <div key={d.id}>{d.email}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
